import { render, staticRenderFns } from "./BaseSidebar.vue?vue&type=template&id=88930530&scoped=true&"
import script from "./BaseSidebar.vue?vue&type=script&lang=js&"
export * from "./BaseSidebar.vue?vue&type=script&lang=js&"
import style0 from "./BaseSidebar.vue?vue&type=style&index=0&id=88930530&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88930530",
  null
  
)

export default component.exports